const authUser = {
	state: {
		authToken: null,
		emailToken: null,
		authUserDetails: null,
		authMessage: {
			status: '',
			message: ''
		}
	},
	mutations: {
		setAuthtoken(state, token) {
			state.authToken = token;
		},
		setEmailToken(state, emailToken) {
			state.emailToken = emailToken;
		},
		setAuthUserDetails(state, details) {
			state.authUserDetails = details;
		},
		clearAuthData(state) {
			state.authToken = null;
			state.emailToken = null;
			state.authUserDetails = null;
		},
		setAuthMessage(state, authMsg) {
			state.authMessage = {...authMsg};
		}
	},
	getters: {
		getAuthToken(state) {
			return state.authToken;
		},
		getEmailToken(state) {
			return state.emailToken;
		},
		getAuthUserDetails(state) {
			return state.authUserDetails;
		},
		getAuthMessage(state) {
			return state.authMessage;
		}
	}
};

export default authUser;
